<template>
  <section class="relative bg-gradient-to-r from-primary/90 to-primary overflow-hidden">
    <div class="absolute inset-0 opacity-10">
      <div class="absolute inset-0 bg-cover bg-center" :style="{ backgroundImage: `url(${bgImage})` }"></div>
    </div>
    <div class="container mx-auto px-4 sm:px-6 lg:px-8 py-16 md:py-24 relative z-10">
      <div class="max-w-3xl mx-auto text-center">
        <h1 class="text-[clamp(2rem,5vw,3.5rem)] font-bold text-white leading-tight drop-shadow-lg animate-fade-in">
          提升技能，成就未来
        </h1>
        <p class="mt-6 text-[clamp(1rem,2vw,1.25rem)] text-white/90 max-w-2xl mx-auto animate-fade-in" style="animation-delay: 0.1s">
          专业的技能培训、就业指导、证书服务一体化平台，助您实现职业目标
        </p>
        <div class="mt-10 flex flex-col sm:flex-row justify-center gap-4 animate-fade-in" style="animation-delay: 0.2s">
          <a href="#courses" class="px-8 py-3 bg-white text-primary font-medium rounded-lg hover:shadow-lg transition-all duration-300 ease-in-out">
            浏览课程
          </a>
          <a href="#register" @click="$emit('open-register-modal')" class="px-8 py-3 bg-secondary text-white font-medium rounded-lg hover:bg-secondary/90 transition-all duration-300 ease-in-out">
            立即注册
          </a>
        </div>
      </div>
    </div>
    <!-- 波浪底部装饰 -->
    <div class="absolute bottom-0 left-0 right-0">
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1440 100" class="w-full h-auto">
        <path fill="#F9FAFB" fill-opacity="1" d="M0,64L60,69.3C120,75,240,85,360,80C480,75,600,53,720,48C840,43,960,53,1080,58.7C1200,64,1320,64,1380,64L1440,64L1440,100L1380,100C1320,100,1200,100,1080,100C960,100,840,100,720,100C600,100,480,100,360,100C240,100,120,100,60,100L0,100Z"></path>
      </svg>
    </div>
  </section>
</template>

<script>
export default {
  name: 'HeroSection',
  data() {
    return {
      bgImage: require('@/assets/3-1920x1080.jpg')
    }
  }
}
</script>

<style scoped>
/* 自定义动画 */
@keyframes fadeIn {
  from { 
    opacity: 0; 
    transform: translateY(10px); 
  }
  to { 
    opacity: 1; 
    transform: translateY(0); 
  }
}

.animate-fade-in {
  animation: fadeIn 0.5s ease forwards;
}
</style> 